export default __webpack_public_path__ + "static/media/paid.fb700657.png";